// 購入エリア：数量・画像切り替え・バリエーション・カート追加
(function () {
  function init(root) {
    var form = root.querySelector('form');
    if (!form) return;

    // 数量
    var qty = root.querySelector('[data-qty-input]');
    function setQty(n) { qty.value = Math.max(1, n || 1); }
    root.querySelector('[data-qty-minus]').addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) - 1); });
    root.querySelector('[data-qty-plus]').addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + 1); });
    qty.addEventListener('change', function () { setQty(parseInt(qty.value, 10)); });

    // 画像の切り替え
    var slides = root.querySelectorAll('[data-slide]');
    root.querySelectorAll('[data-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var i = btn.getAttribute('data-thumb');
        slides.forEach(function (s) { s.hidden = s.getAttribute('data-slide') !== i; });
        root.querySelectorAll('[data-thumb]').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });

    // バリエーション
    var addBtn = root.querySelector('[data-add]');
    var addLabel = root.querySelector('[data-add-label]');
    var stickyBtn = root.querySelector('[data-add-sticky]');
    var stickyPrice = root.querySelector('[data-price-now-sticky]');
    var soldOutText = addLabel ? addLabel.getAttribute('data-sold-out') : null;
    var defaultLabel = addLabel ? addLabel.textContent.trim() : '';
    var select = root.querySelector('[data-variant-select]');
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var now = root.querySelector('[data-price-now]');
        now.textContent = opt.getAttribute('data-price');
        var compare = root.querySelector('[data-price-compare]');
        var compareText = opt.getAttribute('data-compare');
        if (compare) {
          compare.textContent = compareText;
          compare.hidden = !compareText;
        }
        if (stickyPrice) stickyPrice.textContent = opt.getAttribute('data-price');
        var available = opt.getAttribute('data-available') === 'true';
        addBtn.disabled = !available;
        if (stickyBtn) stickyBtn.disabled = !available;
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', select.value);
          window.history.replaceState({}, '', url);
        } catch (e) {}
      });
    }

    // カート追加（通知パネル／その場で表示する設定のとき）
    var status = root.querySelector('[data-status]');
    function say(text, isError, withLink) {
      status.hidden = false;
      status.classList.toggle('is-error', !!isError);
      status.textContent = text;
      if (withLink) {
        var a = document.createElement('a');
        a.href = root.getAttribute('data-cart-url');
        a.textContent = withLink;
        status.appendChild(document.createTextNode(' '));
        status.appendChild(a);
      }
    }
    function updateCount(cart) {
      var cartLink = document.querySelector('.header__cart');
      if (!cartLink) return;
      var badge = cartLink.querySelector('.header__cart-count');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'header__cart-count';
        cartLink.appendChild(badge);
      }
      badge.textContent = cart.item_count;
      badge.classList.remove('is-bounce');
      void badge.offsetWidth;
      badge.classList.add('is-bounce');
    }
    function getCart() {
      return fetch(root.getAttribute('data-cart-json-url'), { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); });
    }
    function formatMoney(cents) {
      var fmt = root.getAttribute('data-money-format') || '{{amount_no_decimals}}';
      var amount = (cents / 100).toFixed(2);
      var noDec = String(Math.round(cents / 100));
      function commas(x) { return x.replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
      var parts = amount.split('.');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return commas(noDec);
        if (k === 'amount') return commas(parts[0]) + '.' + parts[1];
        return commas(noDec);
      });
    }

    var afterAdd = root.getAttribute('data-after-add');
    var buttons = [addBtn, stickyBtn].filter(Boolean);

    // ボタンの文言を変える（ページ内のボタンは文言の span、下部固定ボタンはボタン自体）
    function labelEl(b) { return b === addBtn ? addLabel : b; }
    var originals = buttons.map(function (b) { return labelEl(b).textContent.trim(); });
    function setButtons(text, disabled) {
      buttons.forEach(function (b, i) {
        labelEl(b).textContent = text === null ? originals[i] : text;
        b.disabled = disabled;
      });
    }
    var resetTimer = null;

    // 追加通知パネル
    var panel = root.querySelector('[data-panel]');
    function q(sel) { return panel.querySelector(sel); }
    function showPanel(opts) {
      var isError = !!opts.error;
      q('[data-panel-title]').textContent = isError ? opts.error : root.getAttribute('data-msg-added');
      panel.classList.toggle('is-error', isError);
      q('[data-panel-item]').hidden = isError;
      q('[data-panel-summary]').hidden = isError;
      var cartBtn = q('[data-panel-cart]');
      var checkoutBtn = q('[data-panel-checkout]');
      cartBtn.hidden = isError;
      if (checkoutBtn) checkoutBtn.hidden = isError;
      q('[data-panel-close-text]').hidden = !isError;
      if (!isError) {
        var item = opts.item;
        var img = q('[data-panel-img]');
        if (item.image) { img.src = item.image; img.hidden = false; } else { img.hidden = true; }
        q('[data-panel-name]').textContent = item.product_title;
        var v = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
        q('[data-panel-variant]').textContent = v;
        q('[data-panel-variant]').hidden = !v;
        q('[data-panel-qty]').textContent = '× ' + item.quantity;
        q('[data-panel-summary]').textContent = root.getAttribute('data-msg-summary')
          .replace('__COUNT__', opts.cart.item_count)
          .replace('__TOTAL__', formatMoney(opts.cart.total_price));
      }
      panel.hidden = false;
      root.classList.add('is-panel-open');
      // 次のフレームで出して、下からの動きを付ける
      requestAnimationFrame(function () {
        panel.classList.add('is-open');
        fitPadding();
      });
    }
    // ページの最後がパネルに隠れないよう、パネルの高さ分の余白を足す
    function fitPadding() {
      if (panel.hidden) return;
      document.body.style.paddingBottom = panel.offsetHeight + 'px';
    }
    function closePanel() {
      if (panel.hidden) return;
      panel.classList.remove('is-open');
      panel.hidden = true;
      root.classList.remove('is-panel-open');
      document.body.style.paddingBottom = '';
    }
    if (panel) {
      panel.querySelectorAll('[data-panel-close], [data-panel-close-text]').forEach(function (b) {
        b.addEventListener('click', closePanel);
      });
      panel.addEventListener('transitionend', fitPadding);
      window.addEventListener('resize', fitPadding);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closePanel();
      });
      var checkoutLink = q('[data-panel-checkout]');
      if (checkoutLink) checkoutLink.href = root.getAttribute('data-checkout-url');
    }

    if (afterAdd === 'message' || (afterAdd === 'panel' && panel)) {
      form.addEventListener('submit', function (e) {
        if (!e.submitter || e.submitter.name !== 'add') return;
        e.preventDefault();
        var usePanel = afterAdd === 'panel';
        clearTimeout(resetTimer);
        if (usePanel) setButtons(root.getAttribute('data-msg-adding'), true);
        else buttons.forEach(function (b) { b.disabled = true; });
        fetch(root.getAttribute('data-cart-add-url'), {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) {
              var msg = res.body.description || res.body.message || root.getAttribute('data-msg-error');
              if (usePanel) { setButtons(null, false); showPanel({ error: msg }); }
              else say(msg, true);
              return;
            }
            return getCart().then(function (cart) {
              updateCount(cart);
              if (usePanel) {
                showPanel({ item: res.body, cart: cart });
                setButtons(root.getAttribute('data-msg-added-button'), true);
                var sec = parseFloat(root.getAttribute('data-added-seconds')) || 2;
                resetTimer = setTimeout(function () { setButtons(null, false); }, sec * 1000);
              } else {
                say(root.getAttribute('data-msg-added') || 'カートに追加しました', false, root.getAttribute('data-msg-view-cart'));
              }
            });
          })
          .catch(function () {
            var msg = root.getAttribute('data-msg-error');
            if (usePanel) { setButtons(null, false); showPanel({ error: msg }); }
            else say(msg, true);
          })
          .then(function () { if (!usePanel) buttons.forEach(function (b) { b.disabled = false; }); });
      });
    }

    // 画面下に固定する購入ボタン
    var sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window && addBtn) {
      new IntersectionObserver(function (entries) {
        sticky.hidden = entries[0].isIntersecting || entries[0].boundingClientRect.top > 0;
      }).observe(addBtn);
    }
  }

  document.querySelectorAll('[data-pm]').forEach(init);
})();
